
import { z } from "zod";

export const ConversationTypeValues = ["PHONE", "EMAIL", "INTERNAL"] as const;
export const ConversationTypeSchema = /* @__PURE__ */ z.enum(ConversationTypeValues);
export const ConversationType: (typeof ConversationTypeSchema)["enum"] = { "PHONE": "PHONE", "EMAIL": "EMAIL", "INTERNAL": "INTERNAL" };
export type ConversationType = (typeof ConversationTypeValues)[number];
export const ConversationTypeDisplayNames = { "PHONE": "Phone",
"EMAIL": "Email",
"INTERNAL": "Message", } satisfies Record<ConversationType, string>;
